import { tokens } from "../../public/tokens";

/**
 * The three CSS custom properties a tenant's brand config sets on `document.body` once
 * `GetBrandColor` resolves (see Header.js) - they supersede every variant's own background,
 * on every variant, not just primary. `:root` in tokens.css/custom.css already declares
 * defaults for these, so the `var(..., fallback)` below is a belt-and-braces fallback for a
 * page where those root defaults are ever missing, not the normal path.
 */
export function brandBackground(cssVar, fallback) {
    return `var(${cssVar}, ${fallback})`;
}

export const defaultFocusVisibleState = {
    outline: `${tokens.globals["spacing-0-5"]} solid ${tokens.colors.brand.blue["500"]}`,
    outlineOffset: tokens.globals["spacing-0-5"],
};
